import { BrowserRouter, Routes, Route } from 'react-router-dom'
import RouterViews from '@/pages/router/Router-views'

function App() {
  return (
    <div className="App">
     <BrowserRouter>
        <Routes>
          <Route path="/*" element={<RouterViews/>}></Route>
        </Routes>
     </BrowserRouter>
    </div>
  )
}

export default App